import React from 'react';

import { API_URLS } from '../../../../helpers/api/API_URLS';

export class Summary extends React.Component {

	render() {
		let currentClient = this.props.currentClient
		let siteCode;
		let contactCount = currentClient.contacts.filter(contact => contact.type !== 'billing').length;
		let storeCount = currentClient.locations.filter(store => store.type !== 'billing').length;
		if (currentClient.clientCode === "fliq") {
			siteCode = "flbl";
		} else {
			siteCode = "www";
		}
		if (!currentClient.productionUrl) {
			currentClient.productionUrl = currentClient.sites[0].url;
		}

		return (
			<React.Fragment>
				{(currentClient.productionUrl && (currentClient.productionUrl !== "http://example.com")) && (
					<div className="summary" id="summary-siteUrl" style={{"textAlign": "center"}}>
						<a href={currentClient.productionUrl} target="_blank" rel="noopener noreferrer">{currentClient.productionUrl}</a>
					</div>
				)}
				<div id="profile-summary">
					<div className="summary" id="summary-contacts">Contacts: {contactCount}</div>
					<div className="summary" id="summary-locations">Store Locations: {storeCount}</div>
					<div className="summary" id="summary-endpoint">
						{(currentClient.dataSource === "sfn") ? (
							<a href={API_URLS.SFN+currentClient.clientCode+"/"+siteCode} target="_blank" rel="noopener noreferrer">Product Data Endpoint</a>
						) : (
							<a href={API_URLS.PRODUCTS+currentClient.clientCode+"/"+siteCode} target="_blank" rel="noopener noreferrer">Product Data Endpoint</a>
						)}
					</div>
				</div>
				<div className="summary" id="summary-sales"></div>
			</React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/ProfileSummary.js